import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const behaviourFields = [
  {
    label: 'On Scan Action',
    name: 'action',
    editor: 'dropdown',
    default: '',
    description: 'An action to run when a QR code is scanned',
    options: [],
    function: {
      name: 'getAppActions',
      params: ['app.id']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  },
  {
    label: 'Mode',
    name: 'mode',
    editor: 'dropdown',
    description: 'The mode of the QR Code element',
    default: 'image',
    options: [
      { label: 'QR Code Image Display', value: 'image' },
      { label: 'QR Code Scanner', value: 'scanner' },
      { label: 'QR Code Creation', value: 'generate' }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
  }
];

const contentFields = [
  {
    label: 'Data Binding Source',
    name: 'datasourceId',
    description: 'Choose a content type this element will get its data from',
    editor: 'dropdown',
    function: {
      name: 'getDynamicDataSources',
      params: ['app.id']
    },
    default: '',
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'Data Binding Field',
    name: 'sourceField',
    editor: 'dropdown',
    description:
      'The field from the underlying datasource will be used as the value of this element',
    default: '',
    options: [],
    function: {
      name: 'getDynamicDataSourceFields',
      params: ['app.id', 'element.datasourceId']
    },
    group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
  },
  {
    label: 'QR Code Content',
    name: 'qrCodeMarkup',
    editor: 'textbox',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
    description:
      'The content markup to include in the generated QR code in the form of ${source.recordField}. Also supports ${source.user.field}',
    default: '',
    options: [],
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'generate'
      }
    ]
  },
  {
    label: 'Storage Path',
    name: 'storagePath',
    editor: 'textbox',
    group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR,
    description:
      'The path in firebase storage to store the generated QR code image',
    default: '',
    options: [],
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'generate'
      }
    ]
  }
];

const colorFields = [
  'color',
  {
    label: 'Spinner Color',
    name: 'spinnerColor',
    editor: 'color',
    description: 'The color of the activity indicator during scan processing.',
    default: '#182fa4',
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'scanner'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.COLORS
  }
];

const fontFields = ['font'];

const imageFields = [
  {
    label: 'Use Original Image',
    name: 'useOriginalImage',
    editor: 'boolean',
    description:
      'If true, uses the original qr code image that was generated instead of a qr code thumbnail',
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'image'
      }
    ]
  },
  {
    label: 'Image Width',
    name: 'width',
    editor: 'number',
    description: 'The width of the image',
    default: 80,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'image'
      }
    ]
  },
  {
    label: 'Image Height',
    name: 'height',
    editor: 'number',
    description: 'The height of the image',
    default: 80,
    group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'image'
      }
    ]
  }
];

const layoutFields = [
  {
    label: 'Spinner Size',
    name: 'spinnerSize',
    editor: 'dropdown',
    description: 'The size of the scanning spinner.',
    default: 'small',
    options: [
      { label: 'Small', value: 'small' },
      { label: 'Large', value: 'large' }
    ],
    displayWhen: [
      {
        field: 'mode',
        operator: '=',
        value: 'scanner'
      }
    ],
    group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
  },
  'alignment',
  'margin',
  'padding',
  'layout'
];

const QrCodeElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'QR Code',
  icon: 'QrCodeBracketIcon',
  description:
    'Adds a QR Code scanner or Displays a QR code for a document field',
  properties: [
    ...behaviourFields,
    ...contentFields,
    ...colorFields,
    ...fontFields,
    ...imageFields,
    ...layoutFields
  ]
};

export default QrCodeElementFields;
